import SidebarItemSimple from '@/components/SidebarItemSimple/SidebarItemSimple';

export default SidebarItemSimple;
